module.exports = "/dist/images/de.dffa19fc.png";